module.exports = __webpack_public_path__ + "static/img/product-wrightin.8d5200f4.png";